import { useEffect } from 'react';
import LoadingCircle from '@/components/loading-circle';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import MouseFlow from '@/utils/mouse-flow';
import Track from '@/utils/track';

const UploadFormSuccess = () => {
  const { success } = useAppSelector(ConfigSlice.selectors.resultPage);

  useEffect(() => {
    MouseFlow.push('newPageView', '/form-upload-page-successfully');
    Track.DataLayer.UploadSuccess();
  }, []);

  return (
    <div className={'wrapper'}>
      <LoadingCircle success={true} fail={false} className='modal-additional-terms-container' />
      <div className='success-text upload-form-success-text'>{success()}</div>
    </div>
  );
};

export default UploadFormSuccess;
